'use client';

import { useState } from 'react';

interface AccordionItem {
  question: string;
  answer: string;
}

interface AccordionProps {
  items: AccordionItem[];
}

export default function Accordion({ items }: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const ChevronIcon = ({ isOpen }: { isOpen: boolean }) => (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`transition-all duration-150 ${isOpen ? 'rotate-180' : ''}`}
    >
      <path
        d="M1 1L7 7L13 1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="w-full max-w-4xl flex flex-col items-center">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={index}
            className="w-full p-4 flex flex-col items-center border-b border-gray-300 transition-all"
          >
            <div
              className="w-full flex items-center justify-between transition-all cursor-pointer"
              onClick={() => toggleItem(index)}
            >
              <div className="font-medium text-xl">{item.question}</div>
              <ChevronIcon isOpen={isOpen} />
            </div>
            <div
              className={`w-full text-gray-500 overflow-clip transition-all duration-150 ease-in-out ${
                isOpen ? 'h-auto opacity-100 mt-2' : 'h-0 opacity-0'
              }`}
            >
              {item.answer}
            </div>
          </div>
        );
      })}
    </div>
  );
}

